export default function FullService() {
    return (
        <div>
            <p>
                When Rolling Thunder Cycles performs a full service on your Harley-Davidson® motorcycle we complete all the checks that the factory recommends and a few of our own.*
            </p>
            <h3>Full service listing: All Models</h3>
            <ul>
                <li>
                    <strong>Change engine oil and filter, replace o-ring as required</strong>
                    <br />
                    We recommend synthetic oils for all aluminum Harley-Davidson® engines. Synthetic oil has better cling for more protection on cold starts; it does not break down hot and will lower the overall operating temperature of your motorcycle by 8 degrees. Older engines should still use petroleum oils due to increased engine tolerances. If you are not sure just give us a call and we will let you know what is best for your application. Petroleum oils should be replaced every 2,500 miles or once a year, Synthetic oils should be replaced every 5,000 miles or once a year.
                </li>
                <li>
                    <strong>Change primary chain lube, clean drain plug, &amp; replace o-ring</strong>
                    <br />
                    Wet clutch Harley-Davidson® motorcycles do not require heavy oil. We recommend synthetic primary chain case fluid to lube the primary chain and act as a coolant for the wet clutch. Petroleum primary chain case fluids are also available.
                </li>
                <li>
                    <strong>Check and adjust primary chain as needed</strong>
                    <br />
                    This is an important check on all pre-2007 models as you can lose performance through an improperly adjusted primary chain. 2007 and newer models are equipped with an automatic chain adjuster.
                </li>
                <li>
                    <strong>Check and adjust clutch release, free play and lube</strong>
                    <br />
                    Lubing and adjusting your bike's clutch cable will extend life and make operating the clutch in traffic easier. Clutch release end play creates the perfect friction zone and extends clutch life.
                </li>
                <li>
                    <strong>Change transmission lubricant, clean drain plug, replace o-ring (as required)</strong>
                    <br />
                    The transmission fluid on big twin engines is a separate fluid in the sealed transmission case. Although it does not get as hot as engine oil, the heating and cooling causes condensation to form which can damage internal parts. Here we also recommend synthetic fluid for ease of shifting and long life. Early model Harley-Davidson® motorcycles using bushings instead of bearings still need petroleum based heavier oil for proper lubrication.
                </li>
                <li>
                    <strong>Check shifter lever Allen bolt on transmission condition and tightness</strong>
                    <br />
                    These grade 8 Allen bolts can stretch and cause shifter linkage to loosen eventually causing the need to replace the shift arm and possibly the shifter shaft in the transmission. Early replacement saves expensive repairs.
                </li>
                <li>
                    <strong>Check and adjust rear belt/chain, lube as required, check for damage</strong>
                    <br />
                    Early model Harley-Davidson® motorcycles using rear chain drives require checking the free play adjustment, sprocket condition and lubrication (about every 500 to 1,000 miles) and generally last no more than 6,000 miles in New York traffic. Rear belts require less attention but debris can lodge between the rear sprocket and belt causing damage you’ll want to know about ahead of time.
                </li>
                <li>
                    <strong>Check mufflers for loose at mount clamps</strong>
                    <br />
                    New York potholes can ruin just about anything and hard impacts coupled with vibration can cause even the best exhaust system to loosen.
                </li>
                <li>
                    <strong>Inspect, clean or replace tappet screen on required models</strong>
                    <br />
                    This screen catches debris before oil goes to the roller tappets and should be cleaned or replaced with every service on 1999 and older models.
                </li>
                <li>
                    <strong>Inspect air cleaner and service</strong>
                    <br />
                    Dirty air cleaners can rob performance, cause excess gas consumption, and increase carbon build-up in engines. Not Good!
                </li>
                <li>
                    <strong>Change spark plugs</strong>
                    <br />
                    Spark plug technology has come a long way and is key to keeping your bike starting easy and running its best.
                </li>
                <li>
                    <strong>Inspect oil lines, fuel lines and shock rubbers for dry rot</strong>
                    <br />
                    All rubber rots and the increase in Ethanol content in gasoline can cause fuel lines to deteriorate. It is always easier to repair before it fails.
                </li>
                <li>
                    <strong>Inspect brake pads and disc wear</strong>
                    <br />
                    There is nothing like knowing your bike will stop when you need it to. Ask about new technology in brake pads to help increase braking power even in ABS models.
                </li>
                <li>
                    <strong>Check brake fluid levels and condition of fluid</strong>
                    <br />
                    Even though brake fluid is sealed in both reservoirs the constant heating and cooling will cause it to break down and require replacing every few seasons.
                </li>
                <li>
                    <strong>Check engine idle speed</strong>
                    <br />
                    Spit and stall problems can be common. Proper engine speed reduces spit and stalls when accelerating from traffic stop lights.
                </li>
                <li>
                    <strong>Check operation of choke/enrichment and cold idle speed (Carb and EFI)</strong>
                    <br />
                    Proper operation of cold idle speed helps prevent spit and stall conditions and is very important in cold weather riding when engine warm-up times are longer.
                </li>
                <li>
                    <strong>Inspect fuel valve, lines and fittings for ease of operation and leaks</strong>
                    <br />
                    Carburetor model Harley-Davidson® motorcycles have manual fuel valves that can be difficult to move from run to reserve position when needed.
                </li>
                <li>
                    <strong>Lube all pivot points and cables (throttle, clutch and drum brake cables, rear brake lever, clutch and brake pivots, shifter linkage heims etc.)</strong>
                    <br />
                    When your bike's controls operate easily the overall riding experience is more fun, and prevents parts from wearing out before they should.
                </li>
                <li>
                    <strong>Check throttle and idle cables and adjust as required</strong>
                    <br />
                    Quick response and proper operation of your bike's acceleration system can sometimes get you out of a tight situation.
                </li>
                <li>
                    <strong>Check steering bearing tension and fork fall away</strong>
                    <br />
                    Critical to your bike's handling both around town and at highway speeds is your fork bearing tension. This is one of the items that will cause your bike to fail inspection and is checked and adjusted as needed with every full service.
                </li>
                <li>
                    <strong>Grease steering bearings (as available) and all grease fittings on chassis</strong>
                    <br />
                    This part of routine maintenance is to extend bearing life on models with available fittings. Other models require the fork to be removed at certain factory recommended intervals.
                </li>
                <li>
                    <strong>Check operation of electrical equipment, lighting, switches, horn</strong>
                </li>
                <li>
                    <strong>Check front brake light switch for sticking and rear brake switch operation</strong>
                </li>
                <li>
                    <strong>Check charging system output and battery terminal connections, clean and lube</strong>
                    <br />
                    It’s always good to know your electrical system is working as it should.
                </li>
                <li>
                    <strong>Check tire air pressures and adjust, inspect tread depth, check for debris</strong>
                    <br />
                    Tire pressure changes at a rate of one (1) pound per 10 degrees of temperature. All tires will lose air when sitting. This should not only be checked during a full service but at least once a week.
                </li>
                <li>
                    <strong>Check wheel spokes for tight and wheel for true</strong>
                    <br />
                    Spoked wheels, especially rear wheels require more maintenance than mag wheels. So don’t only keep your chrome spokes clean, keep them tight too!
                </li>
                <li>
                    <strong>Check ignition timing (XL models only)</strong>
                    <br />
                    With the quality of today’s gasoline, ignition ping can be a problem on older models. The ignition timing can be adjusted to help compensate for lower quality gas.
                </li>
                <li>
                    <strong>Road test upon completion of work</strong>
                    <br />
                    A road test is a very necessary part of a full service. Nothing tells the technician more about your motorcycle than driving it.
                </li>
            </ul>
            <p>
                Over the years of performing full services on all makes and models of Harley-Davidson® motorcycles we have found a few additional items the factory does not list in their service manuals. These items listed below are just a few.
            </p>
            <h4>Touring:</h4>
            <ul>
                <li>Check rear fender mounts to muffler supports for cracked or broken</li>
                <li>Check rear bumper at mount points for cracked or broken</li>
                <li>Check air pressure on front and rear suspension as required</li>
                <li>Check crossover exhaust pipe for cracked</li>
            </ul>
            <h4>Older Models:</h4>
            <ul>
                <li>Check and adjust pushrods as required</li>
                <li>Inspect advance/retard mechanism and service repair and lube as required</li>
            </ul>
            <p>
                <em>*Fork oil changes and bearing services vary per model and are not listed here</em>
            </p>
        </div>
    );
}
